import React, { Component } from 'react';

export default class extends Component {
    render() {
        // TAG UI 만들기
        var tagList = [];

        for (var i = 0; i < this.props.tagList.length; i++) {
            tagList.push(<div key={i} className="tag"><p className="tag-shap">#</p>{this.props.tagList[i]}</div>);
        }

        return (
            <div className="content-header">
                <h2 className="title">{this.props.title}</h2>
                <div className="tag-box">
                    {tagList}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/ContentHeader.js